/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import cn from 'classnames';
import React from 'react';
import { compose } from 'redux';
import htmlDecodeEntities from '../../Support/Html/DecodeEntities/HtmlDecodeEntities.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrderTime from '../OrderTime/OrderTime.component';
import OrderTitlePropTypes from './OrderTitle.component.props';
import orderTitleStyles from './OrderTitle.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * OrderTitleComponent
 * @param {Object} props props
 * @returns {React.Component} component
 */
export const OrderTitleComponent = (props) => {
  const { title, subTitle, startTime, classes, width, qaDayAttribute } = props;
  const decodedSubTitle = htmlDecodeEntities(subTitle);
  const smallScreen = isWidthDown(`md`, width);

  return smallScreen ? (
    <div className={cn(classes.overflowHidden)}>
      <Grid alignItems="center" container className={cn(classes.flexWrapNowrap)} justify="flex-start">
        <Grid container spacing={2} className={cn(classes.flexWrapNowrap, classes.overflowHidden, classes.title)}>
          <Grid item>
            <OrderTime date={startTime} />
          </Grid>
          <Grid item className={cn(classes.overflowHidden)}>
            <Grid container spacing={1} alignItems="center" className={cn(classes.overflowHidden, classes.flexWrapNowrap)}>
              <Grid item>
                <LocationOnIcon fontSize="small" />
              </Grid>
              <Grid item className={cn(classes.overflowHidden)}>
                <Typography className={classes.wrapText} variant="overline" data-mf-replace-inner={MFSDR}>
                  <span data-qa-day-inner={qaDayAttribute}>{title}</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Typography className={classes.wrapText} variant="h6">
        {decodedSubTitle}
      </Typography>
    </div>
  ) : (
    <Grid container>
      <Grid item md={12}>
        <Grid alignItems="center" container className={classes.flexWrapNowrap} justify="flex-start">
          <Grid item>
            <LocationOnIcon fontSize="small" />
          </Grid>
          <Grid item className={cn(classes.dateTimeLabel, classes.overflowAuto)}>
            <Typography className={classes.wrapText} variant="overline" data-mf-replace-inner={MFSDR}>
              <span data-qa-day-inner={qaDayAttribute}>{title}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid alignItems="center" container justify="flex-start">
          <Typography className={classes.wrapText} variant="h6">
            {decodedSubTitle}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
OrderTitleComponent.displayName = `OrderTitle`;
OrderTitleComponent.propTypes = OrderTitlePropTypes;

/** @type {React.ComponentClass<OrderTitleComponentProps>} */
const OrderTitle = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderTitleStyles), { withTheme: true }),
)(OrderTitleComponent);

export default OrderTitle;
